import { z } from 'zod';
import { baseStructureSchema, baseSettingsSchema } from './base.structure.js';
import { slideElementSchema } from './slide.element.js';

const slideV2StructureSchema = baseStructureSchema.extend({
  settings: baseSettingsSchema.extend({
    hasCorrectAnswer: z.literal(false)
  }),
  elements: z.array(slideElementSchema),
  answer: z.literal(-1),
  media: z.record(z.unknown()).optional()
});

export { slideV2StructureSchema };
